import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { ReportCache } from 'core-lib';
import { ReportCacheService } from "core";
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { getLoadedStatuses, getLoadingStatuses, LoadBrandsData, LoadDriver, LoadLinescore, LoadOther, LoadVerbatims, ReportsState } from '../store';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-table-options',
    templateUrl: './table-options.component.html',
    styleUrls: ['./table-options.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, FormsModule, NgFor, MatOptionModule, NgIf, MatProgressBarModule, MatButtonModule, MatIconModule]
})
export class TableOptionsComponent implements OnInit {

  disable: boolean = false;
  columns: string = 'standard';
  rowPercent: boolean = true;
  columnsOpts: { value: string, label: string }[] = [];

  constructor(
    private dialogRef: MatDialogRef<TableOptionsComponent>,
    private store: Store<ReportsState>,
    private rc: ReportCacheService,
    @Inject(MAT_DIALOG_DATA) public data: { reportCache: ReportCache }
  ) { }

  process() {
    this.disable = true;
    const cache = this.data.reportCache;

    this.rc.updateCacheParams(this.data.reportCache.cache_key, {
      suppress_columns: this.columns,
      row_percents: this.rowPercent
    }).pipe(
      switchMap(result => {
        return this.store.pipe(
          select(getLoadedStatuses),
          tap(({ brands, linescore, verbatims, other, driver }) => {
            if (brands)
              this.store.dispatch(new LoadBrandsData(cache.cache_key));
            if (linescore)
              this.store.dispatch(new LoadLinescore(cache.cache_key));
            if (verbatims)
              this.store.dispatch(new LoadVerbatims(cache.cache_key));
            if (other)
              this.store.dispatch(new LoadOther({ cacheKey: cache.cache_key, crosstab: cache.report_type === 'crosstab' }));
            if (driver)
              this.store.dispatch(new LoadDriver(cache.cache_key));
          }),
          take(1),
          switchMap(() => {
            return this.store.pipe(
              select(getLoadingStatuses),
              filter(statuses => {
                for (const x in statuses) {
                  if (statuses[x])
                    return false;
                }
                return true;
              }),
              take(1)
            );
          })
        )
      })
    ).subscribe(() => {
      this.dialogRef.close();
    });

  }

  ngOnInit(): void {
    const colOpts: { value: string, label: string }[] = [{
      value: 'standard',
      label: 'Default columns'
    }, {
      value: 'nobase',
      label: 'Hide base column'
    }];
    const rCache = this.data.reportCache;
    if (rCache.report_type === 'linescore')
      colOpts.push({ value: 'TA', label: 'Totals and Acceptors Only' });
    if (rCache.report_type === 'type3' || rCache.report_type === 'linescore')
      colOpts.push({ value: 'A', label: 'Acceptors only' });

    this.columnsOpts = colOpts;
    this.columns = rCache.parameters.suppress_columns;
    this.rowPercent = rCache.parameters.row_percents;
  }

}
